import angular from 'angular';
import { CorporationManagerListComponent } from './corporation-manager-list.component';
import { EditCorporationManagerComponent } from './edit-corporation-manager.component';
import { IcdCorporationManagerRoutingModule } from './icd-corporation-manager-routing.module';

export const IcdCorporationManagerModule = angular
    .module("apex.mainApp.icdCorporationManager", [
        IcdCorporationManagerRoutingModule
    ])
    .component("apexCorporationManagerList", CorporationManagerListComponent)
    .component("apexEditCorporationManager", EditCorporationManagerComponent)
    .name;
